import { useTranslation } from 'next-i18next';

type LoaderProps = {
  loaderMessage?: string;
  fullPage?: boolean;
  darkOverlay?: boolean;
};

export const Loader = ({ loaderMessage, darkOverlay = true, fullPage = true }: LoaderProps) => {
  const { t } = useTranslation(['free-form-hub/freeFormHub', 'common']);
  const defaultLoaderMessage = t(`COMMON.LOADING`, { ns: 'free-form-hub/freeFormHubCommon' });

  if (fullPage) {
    return (
      <div
        role="dialog"
        className={`fixed flex flex-col justify-center items-center top-0 left-0 bottom-0 right-0 z-[101] h-full ${
          darkOverlay ? 'bg-gray-600' : ''
        } bg-opacity-60`}
      >
        <div className="w-28 h-28 rounded-full animate-spin border-solid border-[#F07D00] border-t-transparent border-2" />
        <span className="mt-6 text-igus-primary">{loaderMessage || defaultLoaderMessage}</span>
      </div>
    );
  }

  return (
    <div className="flex flex-row justify-center items-center h-[200px]">
      <div className="w-16 h-16 rounded-full animate-spin border-solid border-[#F07D00] border-4 border-t-transparent border-2" />
      <span className="ml-8 text-2xl">{loaderMessage || defaultLoaderMessage}</span>
    </div>
  );
};
